import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SIZES } from '../../constants';

const Menu = (props) => {
  const {
    selectProps: { size },
  } = props;

  const classes = classNames('ws-ui-base-select-menu', `ws-ui-base-select-menu--${size}`);

  return <components.Menu className={classes} {...props} />;
};

Menu.propTypes = {
  selectProps: PropTypes.shape({
    size: PropTypes.oneOf(Object.values(SIZES)),
  }).isRequired,
};

export default Menu;
